import CustomModalBody from "components/Modal/body";
import CustomModalFooter from "components/Modal/footer";
import { useState } from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";

export default function FilterForm({ onSubmit, onChangeHOC, handleState }) {
    const [invoiceStartDate, setInvoiceStartDate] = useState(null);
    const [invoiceEndDate, setInvoiceEndDate] = useState(null);
    const [invoiceNumber, setInvoiceNumber] = useState("");
    const [plan, setPlan] = useState("");
    const [orderDesc, setOrderDesc] = useState("");
    const [orderAddOns, setOrderAddOns] = useState("");
    const [invoiceAmount, setInvoiceAmount] = useState("");
    const [sinChew, setSinChew] = useState("");
    const [nanYang, setNanYang] = useState("");
    const [chinaPress, setChinaPress] = useState("");

    const handleClear = () => {
        setInvoiceStartDate("");
        setInvoiceEndDate("");
        setInvoiceNumber("");
        setPlan("");
        setOrderDesc("");
        setOrderAddOns("");
        setInvoiceAmount("");
        setSinChew("");
        setNanYang("");
        setChinaPress("");
    };

    const generateQuery = () => {
        let queryString = "";

        if (invoiceStartDate) { queryString += `&invoice_start_date=${invoiceStartDate}` }
        if (invoiceEndDate) { queryString += `&invoice_end_date=${invoiceEndDate}` }
        if (invoiceNumber) { queryString += `&invoice_no=${invoiceNumber}` }
        if (plan){ queryString += `&plan_name=${plan}`}
        if (orderDesc){ queryString += `&order_description=${orderDesc}`}
        if (orderAddOns){ queryString += `&order_add_ons=${orderAddOns}`}
        if (invoiceAmount){ queryString += `&invoice_amount=${invoiceAmount}`}
        if (sinChew){ queryString += `&sin_chew=${sinChew}`}
        if (nanYang){ queryString += `&nan_yang=${nanYang}`}
        if (chinaPress){ queryString += `&china_press=${chinaPress}`}

        return queryString;
    };

    return (
        <>
            <CustomModalBody>
                <Form id="billing-filter-form">
                    <Row>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="invoiceStartDate">Invoice Start Date</Label>
                                <Input
                                    type="date"
                                    placeholder="Enter Invoice Start Date"
                                    name="invoiceStartDate"
                                    id="invoiceStartDate"
                                    value={invoiceStartDate}
                                    onChange={(e) => { setInvoiceStartDate(e.target.value) }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="invoiceEndDate">Invoice End Date</Label>
                                <Input
                                    type="date"
                                    placeholder="Enter Invoice End Date"
                                    name="invoiceEndDate"
                                    id="invoiceEndDate"
                                    value={invoiceEndDate}
                                    onChange={(e) => { setInvoiceEndDate(e.target.value) }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="invoiceNumber">Invoice No.</Label>
                                <Input
                                    placeholder="Enter Invoice No."
                                    name="invoiceNumber"
                                    id="invoiceNumber"
                                    value={invoiceNumber}
                                    onChange={(e) => { setInvoiceNumber(e.target.value) }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="plan">Plan</Label>
                                <Input
                                    type="select"
                                    placeholder="Enter Plan"
                                    name="plan"
                                    id="plan"
                                    value={plan}
                                    onChange={(e) => {setPlan(e.target.value)}}
                                >
                                    <option value="">All</option>
                                    <option value="Plan A">Plan A</option>
                                    <option value="Plan B">Plan B</option>
                                    <option value="Plan C">Plan C</option>
                                    <option value="Plan D">Plan D</option>
                                    <option value="Plan E">Plan E</option>
                                    <option value="Plan F">Plan F</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="orderDesc">Order Description</Label>
                                <Input
                                    placeholder="Enter Order Description"
                                    name="orderDesc"
                                    id="orderDesc"
                                    value={orderDesc}
                                    onChange={(e) => {setOrderDesc(e.target.value)}}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="orderAddOns">Order Add -Ons</Label>
                                <Input
                                    placeholder="Enter Order Add -Ons"
                                    name="orderAddOns"
                                    id="orderAddOns"
                                    value={orderAddOns}
                                    onChange={(e) => { setOrderAddOns(e.target.value) }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="invoiceAmount">Invoice Amount</Label>
                                <Input
                                    placeholder="Enter Invoice Amount"
                                    name="invoiceAmount"
                                    id="invoiceAmount"
                                    value={invoiceAmount}
                                    onChange={(e) => { setInvoiceAmount(e.target.value) }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="sinChew">SinChew</Label>
                                <Input
                                    placeholder="Enter SinChew"
                                    name="sinChew"
                                    id="sinChew"
                                    value={sinChew}
                                    onChange={(e) => { setSinChew(e.target.value) }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="nanYang">NanYang</Label>
                                <Input
                                    placeholder="Enter NanYang"
                                    name="nanYang"
                                    id="nanYang"
                                    value={nanYang}
                                    onChange={(e) => { setNanYang(e.target.value) }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="chinaPress">ChinaPress</Label>
                                <Input
                                    placeholder="Enter ChinaPress"
                                    name="chinaPress"
                                    id="chinaPress"
                                    value={chinaPress}
                                    onChange={(e) => { setChinaPress(e.target.value) }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </CustomModalBody>
            <CustomModalFooter
                rightButton={[
                    {
                        color: "danger",
                        outline: true,
                        content: "Clear All",
                        onClick: () => handleClear(),
                    },
                    {
                        color: "primary",
                        content: "Submit",
                        onClick: () => {
                            const queryString = generateQuery();
                            onSubmit(queryString);
                            handleState({ filterQuery: queryString });
                            onChangeHOC("showFilterModal", false);
                            onChangeHOC("reportPages", 1);
                        },
                    },
                ]}
            />
        </>
    );
}